<template>
  <div :class="classNames">
    <input
      :id="id"
      :checked="value"
      @change="$emit('change', $event.target.checked)"
      :disabled="disabled"
      type="checkbox"
    />
    <label :for="id"></label>
  </div>
</template>

<script>
import style from "./style.module.scss";
export default {
  name: "switcher",
  props: {
    theme: {
      type: String,
      default: "",
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    value: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      style: style,
      id: `f${(~~(Math.random() * 1e8)).toString(16)}`,
    };
  },
  computed: {
    classNames() {
      const classNames = [this.style.switcher];

      switch (this.theme) {
        case "white":
          classNames.push(this.style.switcherWhite);
          break;
        default:
          classNames.push(this.style.switcherBlack);
          break;
      }

      if (this.disabled) classNames.push(this.style.switcherDisabled);

      return classNames;
    },
  },
};
</script>